import { useEffect } from "react";

import { setDefaultSetting } from "../store";
import { DynamicTableDataType } from "./types";

export function useSyncDefaultSettingApplications(
    data: DynamicTableDataType,
    defaultSetting: Record<string, unknown>
) {
    useEffect(() => {
        if (data.data === undefined) return;
        setDefaultSetting({
            ...defaultSetting,
            applications: { data: data.data?.map((item) => ({ ...item })) },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
}
